// extracted by mini-css-extract-plugin
export default {"err":"Error_err__QJzAM","modal":"Error_modal__H0oWx","err_container":"Error_err_container__m8Ao2","heading":"Error_heading__bod5W","error":"Error_error__My7Ol"};